import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const LegalSolutionPage = () => <SearchLandingPage config={searchLandingPages.legal} />;

export default LegalSolutionPage;
